import { useSelector } from "react-redux";
import { Container, Typography, Box, Link} from "../../../third-party-lib";


function Copyright({tenant}) {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href={tenant.BaseUrl}>
        {tenant.Name} StateReport
      </Link>{" "}
      {new Date().getFullYear()}
      {/* {". Built By MedQuest - "} */}
    </Typography>
  );
}
export default function FwFooter() {
   const tenant = useSelector((state) => state.tenantConfig);
  return (
    <div style={{ borderTop: "1px solid #ccc" }}>
      <Container component="main" maxWidth="xs">
        <Box>
          <Copyright tenant={tenant} />
        </Box>
      </Container>
    </div>
  );
}
